import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { registerLocaleData } from '@angular/common';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

import localeSv from '@angular/common/locales/sv';
import localeDa from '@angular/common/locales/da';

if (environment.production) {
  enableProdMode();
}

registerLocaleData(localeSv, 'sv');
registerLocaleData(localeDa, 'da');

platformBrowserDynamic().bootstrapModule(AppModule)
  .catch(err => console.log(err));
